<template>
  <modal :modal-key="'confirm-purchase-pin-error-modal'" :class-style="'modal--welcomeback modal--zero-balance'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_confirm_purchase_for_pin_oups_something }}</h1>
      <img class="usericon" src="static/images/sad_face.svg" alt="">
    </template>
    <template slot="body">
      {{ getTranslations.home_modals_confirm_purchase_for_pin_bundles_are_currently }}
    </template>
    <template slot="footer">
    </template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

// modal_operator_down_PIN
export default {
  name: 'confirm-purchase-for-pin-error',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ConfirmPurchaseForPinError.vue